export const USER_ENTITY_ID = 'USER';
export const GROUP_ENTITY_ID = 'GROUP';
export const USERS_GROUP_ENTITY_ID = 'USERS_GROUP';
export const QUERY_GROUP_ENTITY_ID = 'USER_QUERY_GROUP';
export const ORGUNIT_ENTITY_ID = 'ORGUNIT';
export const CORE_MODULE_ID = '00000000-0000-0000-0000-000000000000';
export const SERVICES_ENTITY_ID = 'SERVICES';
export const REQUEST_ENTITY_ID = 'REQUEST';
export const REPORT_ENTITY_ID = 'REPORT';
export const DATA_COLLECTION_TYPE = 'DataCollection';
export const DATA_MODULE_TYPE = 'DataModule';
export const STATISTICS_QUERY_ID = 'StatisticQuery';
export const DATA_VIEWS_ID = 'DataViews';
export const DATA_REPORT_ID = 'Report';
export const GENERIC_VIEW_ID = 'GenericView';
export const SYSTEM_OBJECT_ID = 'SYSTEM_OBJECT';
export const DASHBOARD_ID = 'DASHBOARD';
export const TIMELINE_CATEGORY_ENTITY_ID = 'POST_CATEGORY';
export const POSTS_ENTITY_ID = 'POSTS';
export const PERSON_ENTITY_ID = 'PERSON';
export const ROLE_ENTITY_ID = 'ROLE';
export const COUNTERS_WIDGET_ID = 'counter_widget';
export const SYSTEM_BUTTON_ID = 'SYSTEM_BUTTON';
export const DOMAIN_ENTITY_ID = 'DOMAIN';
export const FUNCTIONS_ENTITY_ID = 'FUNCTIONS';
export const AUDIT_ENTITY_ID = 'AUDIT';
export const VALIDATOR_ENTITY_ID = 'VALIDATOR';
export const WORKING_HOURS_ENTITY_ID = 'WORKING_HOURS';
export const TEMPLATES_ENTITY_ID = 'TEMPLATES';
// Views
export const SERVICE_CATALOG_VIEW_ID = 'SERVICE_CATALOG';
export const MY_REQUESTS_VIEW_ID = 'ONGOING_MY_REQUESTS';
export const INBOX_REQUESTS_VIEW_ID = 'ONGOING_INBOX';
export const ONGOING_OBSERVER_VIEW_ID = 'ONGOING_OBSERVER';
export const MY_PROFILE_VIEW_ID = 'MY_PROFILE';
export const DATA_QUERY_ID = 'DataQuery';
export const MY_NOTIFICATION_VIEW_ID = 'MY_NOTIFICATIONS';

export const NOTIFICATION_ENTITY_ID = 'NOTIFICATION';
// Request types
export const enum RequestTypeEnum {
  Inbox = 'INBOX',
  MyRequest = 'MY_REQUESTS',
  OBSERVER = 'OBSERVER',
}

export const SPACE_CORE_ENTITY_ID = 'SPACE';
export const SPACE_USERS_CORE_ENTITY_ID = 'SPACE_USERS';
export const SPACE_CORE_ENTITY = 'space';
export const SPACE_USERS_CORE_ENTITY = 'space_users';
export const ROOT_SPACE_ID = 'ROOT';
export const SPACE_RELATION_ON_USER_ENTITY = 'SPACE_RELATION_ON_USER_ENTITY';
export const SPACE_RELATION_ON_SPACE_ENTITY = 'SPACE_RELATION_ON_SPACE_ENTITY';

export const SPACE_STANDALONE_TYPE_ID = 'STANDALONE';
export const SPACE_SUB_TYPE_ID = 'SUB_SPACE';

export const PUBLIC_STORE_ID = 'PUBLIC';
export const PRIVATE_STORE_ID = 'PRIVATE';

///tabs

export const LANGUAGE_ID = 'LANGUAGE';
export const THEME_ID = 'THEME';
export const FONT_ID = 'FONTS';
export const TIME_ZONE_ID = 'TIME_ZONE';
export const SETTINGS_ID = 'SETTINGS';

export const UNSTRUCTURED_ENTITIES_ID = [GENERIC_VIEW_ID];

// WORKFLOWS
export const ADHOC_STEP_ID = 'ADHOC_STEP';
